import React from "react";
import "../index.css";
function Search({ handleInput, search }) {
  return (
    <section className="searchbox-wrap">
      <input
        type="text"
        className="searchbox"
        placeholder="Search the for the movie..."
        onChange={handleInput}
        onKeyPress={search}
      />
    </section>
  );
}

export default Search;
